<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<p class="copy">Originally published in Great Britain 2004 as</p>
<p class="copy"><em class="italic">Perspective, Depth and Distance</em></p>
<p class="copy-2">Search Press Limited,</p>
<p class="copy">Wellwood,</p>
<p class="copy">North Farm Road,</p>
<p class="copy">Tunbridge Wells,</p>
<p class="copy">Kent TN2 3DR</p>
<p class="copy-2">Text copyright © Geoff Kersey 2017</p>
<p class="copy-2">Photographs by Charlotte de la Bédoyère at</p>
<p class="copy">Search Press Studios, except for those on pages <a href="#/xhtml/08_Chapter01#page_9">9–14</a>, 18, 118–127, 131–141, by Paul Bricknell.</p>
<p class="copy-2">Photographs and design copyright</p>
<p class="copy">© Search Press Ltd. 2017</p>
<p class="copy-2">All rights reserved. No part of this book, text, photographs or illustrations may be reproduced or transmitted in any form or by any means by print, photoprint, microfilm, microfiche, photocopier, internet or in any way known or as yet unknown, or stored in a retrieval system, without written permission obtained beforehand from Search Press.</p>
<p class="copy-2">ISBN 978-1-78221-311-6</p>
<p class="copy">eISBN 978-1-78126-348-8</p>
<p class="copy-2">The Publishers and author can accept no responsibility for any consequences arising from the information, advice or instructions given in this publication.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Copyright.vue?1599d863